import React from 'react';
import Grid from '@sendgrid/style-guide-grid';
import { TextInput, Button } from '@sendgrid/ui-components';
import PropTypes from 'prop-types';
import withEmailConfirmationInputs from '../containers/withEmailConfirmationInputs';

export class EmailConfirmationForm extends React.Component {
  constructor(props) {
    super(props);
    this.isFormDisabled = true;
  }

  componentWillUpdate(nextProps) {
    this.isFormDisabled = !(nextProps.emailConfirmationInputs.isValidForm);
  }

  onSend(isFormDisabled) {
    if (!isFormDisabled) {
      this.props.onSend(this.props.emailConfirmationInputs.email);
    }
  }
  render() {
    return (
      <section data-role="email-confirmation-container">
        <div className={Grid.row}>
          <div className={Grid['col-12']}>
            <TextInput
              type="text"
              label="Email Address"
              id="email-confirmation-id"
              isRequired
              onChange={this.props.setConfirmationEmail}
              isValid={this.props.emailConfirmationInputs.emailError === null}
              value={this.props.emailConfirmationInputs.email}
              info={this.props.emailConfirmationInputs.emailError}
              data-role="email-confirmation-id"
            />
            <p>{this.props.emailConfirmationInputs.emailSent ? 'Confirmation email sent.' : <br />}</p>
            <Button
              type="primary"
              onClick={() => this.onSend(this.isFormDisabled)}
              data-role="send-button"
              disabled={this.isFormDisabled}
            >
            Send
            </Button>

          </div>
        </div>
      </section>
    );
  }
}
EmailConfirmationForm.propTypes = {
  setConfirmationEmail: PropTypes.func.isRequired,
  emailConfirmationInputs: PropTypes.shape({
    email: PropTypes.string,
    emailError: PropTypes.string,
    emailSent: PropTypes.bool,
  }).isRequired,
  onSend: PropTypes.func.isRequired,
};

export default withEmailConfirmationInputs(EmailConfirmationForm);



// WEBPACK FOOTER //
// ./src/components/EmailConfirmationForm.jsx